declare var jQuery: any;
declare var wp: any;
declare var window: any;
declare var plupload: any;
declare var _: any;
declare var _wpPluploadSettings: any;
declare var frontendUploadLocalize: any;
declare var vmMarketing: any;
import swal from 'sweetalert';
import { Ajax } from './ajax_helper';
import * as CryptoJS from 'crypto-js';
// @ts-ignore
import ImageTools from './ImageTools.js';

/**
 * Id of the folder the upload should be filed into, or 0 when none is selected.
 *
 * This uploader sends the file straight from the browser to BackBlaze and then POSTs the
 * result to lms_product_upload_file, so it never passes through async-upload.php and Real
 * Media Library's own multipart parameter (rmlFolder) is never sent. RML does not merely
 * ignore a missing folder -- it files the new attachment into the root folder -- which is
 * why uploads made with a folder selected still landed in Unorganized.
 *
 * Sent as rml_folder rather than rmlFolder deliberately: the server side validates that the
 * current user is allowed to place a file in that folder before handing it to RML.
 */
function getSelectedRmlFolder(): number {
    // 1. Real Media Library's own "upload to folder" selector, when the modal renders one.
    //    Prefer a visible instance: the media modal and the page behind it can both have one.
    try {
        const selectors = jQuery('[name="rmlFolder"]');
        const selector = selectors.filter(':visible').length ? selectors.filter(':visible').last() : selectors.last();

        if (selector.length) {
            const fromSelector = parseInt(selector.val(), 10);

            if (!isNaN(fromSelector) && fromSelector > 0) {
                return fromSelector;
            }
        }
    } catch (e) {
        // No selector on this page; fall through.
    }

    // 2. A folder tracker, if one is present.
    if (typeof window.getRMLCurrentFolder === 'function') {
        const fromTracker = parseInt(window.getRMLCurrentFolder(), 10);

        if (!isNaN(fromTracker) && fromTracker > 0) {
            return fromTracker;
        }
    }

    // 3. The folder currently being browsed, e.g. upload.php?rml_folder=123.
    try {
        const fromUrl = parseInt(new URLSearchParams(window.location.search).get('rml_folder') || '', 10);

        if (!isNaN(fromUrl) && fromUrl > 0) {
            return fromUrl;
        }
    } catch (e) {
        // URLSearchParams unavailable; ignore.
    }

    return 0;
}

// Add function to check if we're on a viwec template page
function isViwecTemplatePage(): boolean {
    return vmMarketing !== undefined;
}

// Add function to show alert only if not on viwec template
function showAlert(title: string, message: string, type: string = 'warning') {
    if (!isViwecTemplatePage()) {
        swal(title, message, type);
    }
}

export function string_to_slug(str: any) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to = "aaaaeeeeiiiioooouuuunc------";
    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

jQuery(document).ready(function ($: any) {
    const ajax = new Ajax(frontendUploadLocalize.ajax_url, frontendUploadLocalize.nonce);
    const max_file_size = frontendUploadLocalize.max_upload_file_size_MB; // In MB
    const displayable_images = ['image/gif', 'image/jpeg', 'image/png', 'image/x-icon', 'image/webp']; //based on file_is_displayable_image function in wp-includes/functions.php from WP images.php

    var newWpMedia: any = {};
    var rmlFolderValue = -1;

    var expiredSession = false;

    window.lms_bb_token_refresher = {
        init() {

            if ("undefined" == typeof frontendUploadLocalize.frontend_upload_details || frontendUploadLocalize.frontend_upload_details.length == 0) {
                return;
            }

            this.upload_url = frontendUploadLocalize.frontend_upload_details.upload_urls[0].url;
            this.auth_token = frontendUploadLocalize.frontend_upload_details.upload_urls[0].token;

            Object.entries(frontendUploadLocalize.thumb_sizes).map(([key, value], i: any) => {
                const upload_url = frontendUploadLocalize.frontend_upload_details.upload_urls[i + 1];
                frontendUploadLocalize.thumb_sizes[key].upload_url = upload_url.url;
                frontendUploadLocalize.thumb_sizes[key].auth_token = upload_url.token;
            })
        },
    }

    function overrideFronEndUpload() {

        if (typeof wp !== 'undefined') {
            if (!wp) {
                return;
            }
        } else {
            return;
        }

        // Hook into wp.media cretion to hijack the uploader


        if (window.wp.original_wp_media) {
            return;
        }
        if (!wp.media) {
            // console.error('wp.media is undefined');
            // setTimeout(() => {
            // overrideFronEndUpload();
            // overrideFrontEndImageEdit();
            // }, 1000);
            return;
        }

        wp.original_wp_media = wp.media;
        const sha1Hashes: any = {};
        wp.media = function (attributes: any) {
            newWpMedia = wp.original_wp_media(attributes);
            if (!attributes.ms_offload) {

                //The set timeout is to make sure the uploader is initialized after the ready event is fired to all the views of the media modal
                setTimeout(() => {
                    if (newWpMedia.uploader) {

                        // Set the max file size                    
                        newWpMedia.uploader.uploader.uploader.settings.filters.max_file_size = Math.ceil(max_file_size * 1000000) + "b";

                        newWpMedia.uploader.uploader.uploader.bind('FilesAdded', function (filesAdded: any) {
                            // debugger
                            // expiredSession = true; //Forces asking for a new frontEndUploadLocalize variable
                        });

                        newWpMedia.uploader.uploader.uploader.bind('BeforeUpload', async function (up: any, file: any) {
                            // debugger
                            const HandleBeforeUpload = (up: any, file: any) => {
                                if (!file.new_file_name) {
                                    const randomString = Math.random().toString(36).substring(2, 15);
                                    const fileNameWithoutExtension = file.name.slice(0, file.name.lastIndexOf('.'));
                                    const fileExtension = file.name.slice(file.name.lastIndexOf('.'));
                                    file.new_file_name = string_to_slug(fileNameWithoutExtension) + '_' + randomString + fileExtension;
                                }

                                if (!sha1Hashes[file.new_file_name]) {
                                    //Stops queue
                                    up.stop();
                                    file.status = plupload.STOPPED;

                                    const reader: any = new FileReader();
                                    reader.onload = function () {

                                        const hash = CryptoJS.SHA1(CryptoJS.enc.Latin1.parse(reader.result));
                                        sha1Hashes[file.new_file_name] = hash.toString(CryptoJS.enc.Hex);

                                        up.settings.headers = {};

                                    file['X-Bz-File-Name'] = frontendUploadLocalize.backblaze_upload_path + '/' + file.new_file_name;
                                    up.settings.headers = {
                                        ...up.settings.headers,
                                        ...frontendUploadLocalize.base_upload_headers
                                    };
                                    up.settings.headers['X-Bz-File-Name'] = file['X-Bz-File-Name'];
                                    up.settings.headers['Content-Type'] = file.type;
                                    up.settings.headers['Authorization'] = window.lms_bb_token_refresher.auth_token;
                                    up.settings.headers['X-Bz-Content-Sha1'] = hash;
                                    //up.settings.headers['X-Bz-Info-b2-cache-control'] = "public; max-age=31536000";

                                    up.settings.multipart = false;
                                    up.settings.url = window.lms_bb_token_refresher.upload_url;
                                    up.settings.resize.enabled = false;

                                        //clean data unrelated to backblaze
                                        delete up.settings.multipart_params.fl_upload_type;
                                        delete up.settings.multipart_params._wpnonce;
                                        delete up.settings.multipart_params.action;
                                        delete up.settings.multipart_params.name;
                                        delete up.settings.multipart_params.post_id;

                                        //Generate the thumbs in case of images
                                        if (file.type.startsWith('image/') && displayable_images.includes(file.type)) {
                                            const nativeFile = file.getNative();

                                            const getImageDimensions = (nativeFile: File): Promise<{ width: number, height: number }> => {
                                                return new Promise((resolve, reject) => {
                                                    const imgReader = new FileReader();
                                                    imgReader.onload = function (e) {
                                                        const img: any = new Image();
                                                        img.src = e.target.result;
                                                        img.onload = function () {
                                                            const width = img.naturalWidth;   // Get the width
                                                            const height = img.naturalHeight; // Get the height
                                                            resolve({ width, height });
                                                        };
                                                    }
                                                    imgReader.onerror = function (err) {
                                                        reject(err);
                                                    }
                                                    imgReader.readAsDataURL(nativeFile);
                                                });
                                            }

                                            getImageDimensions(nativeFile)
                                                .then((dimensions) => {
                                                    file.lms_dimensions = dimensions;

                                                    setTimeout(() => {
                                                        file.status = plupload.QUEUED;
                                                        up.start();
                                                    }, 10)
                                                });
                                        } else {
                                            //Continue upload queue, starting form this upload
                                            setTimeout(() => {
                                                file.status = plupload.QUEUED;
                                                up.start();
                                            }, 10)
                                        }

                                    };

                                    const source = file.getNative();
                                    reader.readAsBinaryString(source);
                                    return false;
                                }

                                return true;
                            }

                            if(!frontendUploadLocalize.frontend_upload_details) {
                                console.log('check_vmuplink_storage_mode');
                                up.stop();
    
                                ajax.restartData();
                                ajax.callWPAjax('check_vmuplink_storage_mode', (resp: any) => {
                                    // debugger
    
                                    if(resp.success && resp.data.mode === 'manual') {
                                        frontendUploadLocalize.frontend_upload_details = resp.data['frontend_upload_details'];
                                        window.lms_bb_token_refresher.init();
                                        HandleBeforeUpload(up, file);
                                    } else {
                                        showAlert(
                                            "Refresh required",
                                            "Storage settings changed since last page load. Please reload the page to apply changes."
                                        );
                                        // debugger
    
                                        up.trigger('Error', {
                                            code : '500',
                                            message : '',
                                            file : file,
                                            response : resp.data['message'],
                                            status : 500,
                                            responseHeaders: []
                                        });
                                    }
                                    
                                });
                            } else {
                                return HandleBeforeUpload(up, file);
                            }

                            return false;
                        });

                        newWpMedia.uploader.uploader.uploader.bind('FileUploaded', function (up: any, file: any, response: any) {
                            if (file.post_id) {
                                return true;
                            }

                            const resp: any = JSON.parse(response.response);
                            resp.success = true;
                            resp.post_mime_type = file.type;
                            resp._wp_attached_file = file['X-Bz-File-Name'];
                            if (file.type.startsWith('image/') && displayable_images.includes(file.type)) {
                                resp.width = file.lms_dimensions.width;
                                resp.height = file.lms_dimensions.height;
                            }
                            response.response = JSON.stringify(resp);
                            console.log('response', response)

                            up.stop();

                            ajax.restartData();
                            ajax.setData('backblaze_response', resp);
                            if (file.type.startsWith('image/') && displayable_images.indexOf(file.type) !== -1) {
                                ajax.setData('lms_dimensions', file.lms_dimensions);
                            }
                            ajax.setData('file_size', file.size);
                            ajax.setData('name', file.new_file_name);

                            const rmlFolderId = getSelectedRmlFolder();

                            if (rmlFolderId > 0) {
                                ajax.setData('rml_folder', rmlFolderId);
                            }

                            ajax.callWPAjax('lms_product_upload_file',
                                (resp: any) => {
                                    if (resp.success) {
                                        file.post_id = resp.data.attachment_for_js.id;

                                        if (file.type.startsWith('image/') && displayable_images.indexOf(file.type) !== -1) {
                                            const nativeFile = file.getNative();
                                            const dimensions = file.lms_dimensions;

                                            // Loop through each size in frontendUploadLocalize.thumb_sizes
                                            const thumbsToUpload: any = [];
                                            const checkAllThumbsAreUploaded = () => {
                                                const allComplete = thumbsToUpload.every((thumb: any) => {
                                                    return (thumb.attachment_generated) || (thumb.error);
                                                });

                                                if (allComplete) {
                                                    up.trigger('UploadProgress', file);
                                                    file.status = plupload.DONE;
                                                    up.trigger('FileUploaded', file, {
                                                        ...response,
                                                        response: JSON.stringify({ data: resp.data.attachment_for_js, success: true }),
                                                    });
                                                    frontendUploadLocalize.frontend_upload_details
                                                    up.start();
                                                }
                                            }

                                            const thumbsUploads = Object.entries(frontendUploadLocalize.thumb_sizes).map(([sizeKey, size]: any, idx: any) => {
                                                if (!size.height) {
                                                    size.height = size.width;
                                                }

                                                if (size.width > dimensions.width && size.height > dimensions.height) {
                                                    //ignore format bigger than the original image
                                                    return 0;
                                                }

                                                const imageTools: any = new ImageTools();

                                                const randomString = Math.random().toString(36).substring(2, 15);
                                                const fileNameWithoutExtension = file.name.slice(0, file.name.lastIndexOf('.'));
                                                const fileExtension = file.name.slice(file.name.lastIndexOf('.'));

                                                thumbsToUpload[idx] = {
                                                    new_file_name: string_to_slug([fileNameWithoutExtension, sizeKey].join('_')) + '_' + randomString + fileExtension,
                                                    nativeFile,
                                                    size,
                                                    idx,
                                                    retriedUpload: 0,
                                                    max_upload_retries: 3,
                                                    max_attachment_creation_retries: 3,
                                                    imageTools,
                                                    error: false,
                                                    resizedFile: false,
                                                    hash: false,
                                                    uploaded: false,
                                                    attachment_generated: false,
                                                    onError: function (err: any) {
                                                        this.error = true;
                                                        console.error(err);
                                                        checkAllThumbsAreUploaded();
                                                    },
                                                    onResize: function (resizedFile: any) {
                                                        this.resizedFile = new File([resizedFile], this.new_file_name);

                                                        const thumbReader: any = new FileReader();
                                                        thumbReader.onload = () => {
                                                            this.onHash(CryptoJS.SHA1(CryptoJS.enc.Latin1.parse(thumbReader.result)));
                                                        }
                                                        thumbReader.onerror = (err: any) => {
                                                            this.onError(err);
                                                        }
                                                        thumbReader.readAsBinaryString(this.resizedFile);
                                                    },
                                                    requestNewUploadUrl: function (hash:any, reference:any) {
                                                        // Make request and override this.size.auth_token and this.size.upload_url

                                                        //ajax action request_fresh_offload_point
                                                        ajax.restartData();
                                                        ajax.setData('backblaze_response', resp);
                                                        if (file.type.startsWith('image/') && displayable_images.indexOf(file.type) !== -1) {
                                                            ajax.setData('lms_dimensions', file.lms_dimensions);
                                                        }
                                                        ajax.setData('size', this.size);
                                                        ajax.callWPAjax('request_fresh_offload_point', (resp: any) => {
                                                            if (resp.success) {
                                                                const first_url = resp.data['upload_urls'][0];
                                                                reference.size.upload_url = first_url['url'];
                                                                reference.size.auth_token = first_url['token'];
                                                                reference.onHash(hash);
                                                            } else {
                                                                reference.onError(resp.data);
                                                            }
                                                        });
                                                    },
                                                    onHash: function (hash: any) {
                                                        this.hash = hash;
                                                        this['X-Bz-File-Name'] = frontendUploadLocalize.backblaze_upload_path + '/' + this.new_file_name;
                                                        this.lms_filename = this.new_file_name

                                                        jQuery.ajax({
                                                            url: this.size.upload_url,
                                                            type: 'POST',
                                                            headers: {
                                                                'Authorization': this.size.auth_token,
                                                                'Content-Type': file.type,
                                                                'X-Bz-File-Name': this['X-Bz-File-Name'],
                                                                'X-Bz-Content-Sha1': this.hash,
                                                                "X-Bz-Info-b2-cache-control": encodeURIComponent("public; max-age=31536000")
                                                            },
                                                            data: this.resizedFile,
                                                            processData: false,
                                                            success: (backblaze_upload_response: any) => {
                                                                backblaze_upload_response.post_mime_type = file.type;
                                                                backblaze_upload_response.lms_filename = this.lms_filename;
                                                                backblaze_upload_response._wp_attached_file = this['X-Bz-File-Name'];
                                                                this.onUploaded(backblaze_upload_response);
                                                                // Handle the success response here
                                                                console.log('Success:', backblaze_upload_response);
                                                            },
                                                            error: (xhr: any, status: any, error: any) => {
                                                                console.error('Error:', status, error, this);
                                                                if ([500, 503].indexOf(xhr.status) !== -1) {
                                                                    setTimeout(() => {
                                                                        this.requestNewUploadUrl(hash, this);
                                                                    }, 10);
                                                                } else if (this.retriedUpload < this.max_upload_retries) {
                                                                    this.retriedUpload++;
                                                                    setTimeout(() => {
                                                                        this.onHash(hash);
                                                                    }, 10); //wait 10ms and try again in case of uploa failure
                                                                } else {
                                                                    // Handle errors here
                                                                    showAlert(
                                                                        "Could not upload file",
                                                                        xhr.responseJSON ? xhr.responseJSON.message : "Unknown error"
                                                                    );
                                                                    if (!error) {
                                                                        error = JSON.parse(xhr.responseText)
                                                                    }
                                                                    console.log('Error:', status, error, this);
                                                                    this.onError(error);
                                                                }
                                                            }
                                                        });

                                                        //Ajax request to backblaze uploading the thumb
                                                    },
                                                    onUploaded: function (backblaze_upload_response: any) {
                                                        const addThumbToAttachmentAjax = new Ajax(frontendUploadLocalize.ajax_url, frontendUploadLocalize.nonce);
                                                        addThumbToAttachmentAjax.setData('backblaze_upload_response', backblaze_upload_response);
                                                        addThumbToAttachmentAjax.setData('sizeKey', sizeKey);
                                                        addThumbToAttachmentAjax.setData('attachment_post_id', file.post_id);
                                                        addThumbToAttachmentAjax.setData('lms_dimensions', size);
                                                        addThumbToAttachmentAjax.setData('file_size', this.resizedFile.size);
                                                        addThumbToAttachmentAjax.callWPAjax('lms_add_offloaded_thumb_to_attachment',
                                                            (resp: any) => {
                                                                if (resp.success) {
                                                                    // this.onAttachmentCreated(resp);
                                                                    const dynamicNonce = resp.data.nonce;
                                                                    const attachmentId = resp.data.attachment_id;
                                                                    const saveCompatAjax = new Ajax(frontendUploadLocalize.ajax_url, dynamicNonce);
                                                                    saveCompatAjax.setData('action', 'save-attachment-compat');
                                                                    saveCompatAjax.setData('id', file.post_id);
                                                                    saveCompatAjax.setData('_wpnonce', dynamicNonce);
                                                                    console.log('RML Folder value:', rmlFolderValue);
                                                                    saveCompatAjax.setData(`attachments[${file.post_id}][rml_folder]`, rmlFolderValue);

                                                                    saveCompatAjax.callWPAjax(
                                                                        'save-attachment-compat',
                                                                        (saveResp: any) => {
                                                                            console.log('Attachment saved successfully', saveResp);
                                                                            try {
                                                                                if (typeof wp !== 'undefined' && wp.media && wp.media.frame && wp.media.frame.content) {
                                                                                    const content = wp.media.frame.content.get();
                                                                                    if (content && content.collection) {
                                                                                    // Reload the list/grid of attachments
                                                                                    content.collection.props.set({ ignore: (+ new Date()) });
                                                                                    content.collection.fetch();
                                                                                    console.log('Media Library refreshed');
                                                                                    }
                                                                            }
                                                                            } catch (err) {
                                                                                console.warn('Could not refresh media library:', err);
                                                                            }
                                                                            this.onAttachmentCreated(resp);
                                                                        },
                                                                        (error: any) => {
                                                                            showAlert(
                                                                            "Could not save attachment",
                                                                            "Something went wrong while saving attachment metadata."
                                                                            );
                                                                            console.log('Save error', error);
                                                                            this.onError(error);
                                                                        }
                                                                    );
                                                                }
                                                            },
                                                            (error: any) => {
                                                                if (!this.retriedAttachmentCreation) {
                                                                    this.retriedAttachmentCreation = 0;
                                                                }

                                                                if (this.retriedAttachmentCreation < this.max_attachment_creation_retries) {
                                                                    this.retriedAttachmentCreation++;
                                                                    setTimeout(() => {
                                                                        this.onUploaded(backblaze_upload_response);
                                                                    }, 10); //wait 10ms and try again in case of uploa failure
                                                                } else {
                                                                    showAlert(
                                                                        "Could not create thumb",
                                                                        "Could not create attachment for thumb on VMuplink for " + sizeKey + " size"
                                                                    );
                                                                    console.log('Error:', error);
                                                                    this.onError(error);
                                                                }
                                                            }
                                                        );

                                                    },
                                                    onAttachmentCreated: function (resp: any) {
                                                        this.attachment_generated = true;
                                                        checkAllThumbsAreUploaded();
                                                    }
                                                };

                                                imageTools.resize(nativeFile, {
                                                    width: size.width,
                                                    height: size.height,
                                                }).then((resizedFile: any) => {
                                                    thumbsToUpload[idx].onResize(resizedFile);
                                                }).catch((err: any) => {
                                                    thumbsToUpload[idx].onError(err);
                                                });

                                                return 1;
                                            });

                                            //When
                                            if (thumbsToUpload.filter((thumb: any) => thumb !== 0).length === 0) {
                                                checkAllThumbsAreUploaded();
                                            }
                                        } else { //Process if no thumb is needed
                                            up.trigger('UploadProgress', file);
                                            file.status = plupload.DONE;
                                            up.trigger('FileUploaded', file, {
                                                ...response,
                                                response: JSON.stringify({ data: resp.data.attachment_for_js, success: true }),
                                            });
                                            up.start();
                                        }
                                    } else {
                                        showAlert(
                                            "Could not upload file",
                                            resp.data[0].message
                                        );
                                    }
                                },
                                (error: any) => {
                                    showAlert(
                                        "Could not upload file",
                                        "Something went wrong!"
                                    );
                                }
                            );

                            return false;
                        }, undefined, 1000);

                        //Refreshes the media modal to make sure the uploaded file is displayed
                        newWpMedia.uploader.uploader.uploader.bind('UploadComplete', function (up: any, files: any) {

                            frontendUploadLocalize.frontend_upload_details = null;
                            if (files.length > 0) {
                                if ( typeof wp.media.frame.content.get() !== 'undefined' ) {
                                    wp.original_wp_media.frame.content.get().collection._requery(true);
                                    wp.original_wp_media.frame.content.get().options.selection.reset();
                                    wp.original_wp_media.frame.content.get().options.selection.set(files[files.length - 1].attachment);
                                } else {
                                }
                            }
                        });

                        newWpMedia.uploader.uploader.uploader.bind('Error', function (up: any, err: any, other: any) {
                            console.log('Error', err, other);
                            showAlert(
                                "Could not upload file",
                                "Something went wrong!"
                            );
                        });
                    }
                }, 150);
            }

            //Copy all properties from old wp.media to the new wp.media
            for (const prop in wp.original_wp_media) {

                if (wp.original_wp_media.hasOwnProperty(prop)) {
                    wp.media[prop] = wp.original_wp_media[prop];
                }
            }

            // console.log('newWpMedia', newWpMedia);
            return newWpMedia;
        }

        //Copy all properties from old wp.media to the new wp.media        
        for (const prop in wp.original_wp_media) {

            if (wp.original_wp_media.hasOwnProperty(prop)) {
                wp.media[prop] = wp.original_wp_media[prop];
            }
        }

        Object.assign(wp.media, wp.original_wp_media);
    }

    if (frontendUploadLocalize.backblaze_offload) {
        if (frontendUploadLocalize.is_beaver_builder) {
            setTimeout(() => {
                overrideFronEndUpload();
            }, 500);
        } else {
            overrideFronEndUpload();
        }
    }

    jQuery(document).on('click', '.media-modal .browser.button-hero', function (e) {
        rmlFolderValue = jQuery('input[name="rmlFolder"]').last().val(); 
    });

});
